import { DestinationType } from '@cbinsights/externalapiservice/externalapiservice';
import { Checkbox, Form, FormInstance, Select } from 'antd';
import {
  DataFeedDestinationFormField,
  DataFeedFormField,
} from './DataFeedForm';

export const destinationCanContinue = (form: FormInstance) =>
  !!form.getFieldValue([
    DataFeedFormField.destination,
    DataFeedDestinationFormField.type,
  ]);

type SupportedDestinationType = DestinationType.DESTINATION_SFTP_INTERNAL;

export const DestinationTypeLabels = {
  [DestinationType.DESTINATION_SFTP_INTERNAL]: 'SFTP',
};

export const isSupportedDestinationType = (
  destination: DestinationType
): destination is SupportedDestinationType =>
  destination in DestinationTypeLabels;

export const DataFeedDestinationTabForm = () => {
  return (
    <>
      <Form.Item
        name={[
          DataFeedFormField.destination,
          DataFeedDestinationFormField.type,
        ]}
        label="Destination"
        required
      >
        <Select placeholder="Select a destination" labelInValue>
          <Select.Option value={DestinationType.DESTINATION_SFTP_INTERNAL}>
            {DestinationTypeLabels[DestinationType.DESTINATION_SFTP_INTERNAL]}
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        name={[
          DataFeedFormField.destination,
          DataFeedDestinationFormField.keepOnlyLatest,
        ]}
        valuePropName="checked"
        noStyle
      >
        <Checkbox>Keep only the most recently-generated feed file(s)</Checkbox>
      </Form.Item>
    </>
  );
};
